export const EMAIL_REGEXP = /^[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,20})$/;
export const PHONE_REGEXP = /^\+?[0-9]{5,12}$/;
export const PASSWORD_REGEXP = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/;
export const NAME_REGEXP = /^[^!-@[-_{-~]{2,}$/;

export function isStringValid( value: string ): boolean {
  return typeof value === 'string'
    && value.length > 0;
}

export function isEmailValid( value: string ): boolean {
  return isStringValid(value)
    && EMAIL_REGEXP.test(value);
}


export function isPhoneValid( value: string ): boolean {
  return isStringValid(value)
    && PHONE_REGEXP.test(value);
}

export function isPasswordValid( value: string ): boolean {
  return isStringValid(value)
    && PASSWORD_REGEXP.test(value);
}



// WEBPACK FOOTER //
// ./app/helpers/validators.ts